import React from "react";

import { CustomSwitch } from "src/app/components/CustomSwitch/CustomSwitch";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import useSortableItem from "src/app/components/VerticalDragAndDropList/useSortableItem";
import { getColumnHeader } from "src/app/pages/CreatorDiscoveryTool/legacy/app/audiences-manager/CreatorResults/utils/getCreatorResultsColumns";
import { ReactComponent as GridIcon } from "src/images/grid.svg";

export default function CreatorSearchColumnRow({
  column,
  isHidden,
  onToggleVisibility,
}) {
  const { attributes, listeners, setNodeRef, style } = useSortableItem(
    column.key,
  );
  const header = getColumnHeader(column.key, column.label);

  return (
    <li
      ref={setNodeRef}
      style={style}
      className="creator-search-columns-dropdown__row"
    >
      <span className="creator-search-columns-dropdown__name">
        <div
          {...attributes}
          {...listeners}
          className="creator-search-columns-dropdown__drag"
        >
          <GridIcon />
        </div>
        <IDHFormattedMessage
          id={header.id}
          defaultMessage={header.defaultMessage}
        />
      </span>
      <CustomSwitch checked={!isHidden} onChange={onToggleVisibility} />
    </li>
  );
}
